import { ref } from "vue";

// Singleton ref para sinalizar quando o i18n está pronto
export const i18nReady = ref(false);

export function useI18nReady() {
  return { i18nReady };
}
